import {
  observable, computed, action, autorun
} from 'mobx';

import { StatusItem } from './StatusItem';
import { unescapeHTML } from '../../../helpers/helpers';
import * as constants from '../../../constants/constants';

export class Card extends StatusItem {
  currency = '';

  commDesc = '';

  href = '';

  imgAlt = '';

  imgSrc = '';

  price = 0;

  skuID = '';

  commRef = '';

  forceRemove = null;

  rootStore = null;

  baseQuantity = 1;

  type = 'card';

  hasRelatedProducts = false;

  elNumberLabel = '';

  @observable elNumber = '';
  @observable deliveryTime = '';
  @observable isInComparator = false;
  @observable compareDisabled = false;
  @observable isClipboardNotify = false;
  @action.bound
  showClipboardNotify() {
    this.isClipboardNotify = true;
    constants.hideEventsArr.forEach((eventType) => {
      window.addEventListener(eventType, this.hideClipboardNotify, eventType === 'touchstart' ? { passive: true } : false);
    });
    setTimeout(this.hideClipboardNotify, constants.notifyTime);
  }
  @action.bound
  hideClipboardNotify() {
    constants.hideEventsArr.forEach((eventType) => {
      window.removeEventListener(eventType, this.hideClipboardNotify, eventType === 'touchstart' ? { passive: true } : false);
    });
    this.isClipboardNotify = false;
  }

  checkComparator = () => {
    const isIn = this.rootStore.comparatorStore.comparatorArr.findIndex((item) => item === this.skuID) !== -1;

    if (isIn !== this.isInComparator) {
      this.updateIsInComparator(isIn);
    }

    this.updateCompareDisabled(isIn);
  };

  // TODO move into comparator checkbox???
  handleCompareClick = () => {
    if (this.isInComparator) {
      this.rootStore.comparatorStore.removeFromCompare(this.skuID);
    } else {
      this.rootStore.comparatorStore.addToCompare(this.skuID);
    }
  };

  constructor({ card, rootStore, remove, shouldSyncAPI, showRelatedProducts, skipQtyValidation }) {
    super({
      item: card, shouldSyncAPI, skipQtyValidation, labelsStore: rootStore.labelsStore
    });
    Object.assign(this, card);
    this.hrefEncoded = encodeURIComponent(encodeURIComponent(this.skuID));
    this.ID = this.skuID;
    this.commRef = this.commRef || this.skuID;
    this.commDesc = unescapeHTML(this.commDesc);
    this.rootStore = rootStore;

    this.baseQuantity = card.quantity;
    this.remove = remove && remove.bind(null, this);

    if (!rootStore.optionsStore.currency) {
      // set currency to optionsStore (not observable property)
      rootStore.optionsStore.currency = this.currency;
    }

    this.showRelatedProducts = showRelatedProducts && this.hasRelatedProducts;

    autorun(this.checkComparator);
  }

  @computed
  get weeePricesData() {
    if (!this.price || !this.quantity) {
      return null;
    }

    const { weeeLamp, weeePackage, weeePro } = this.weeePrices || {};
    const hasWeeePrices = Boolean(weeeLamp || weeePackage || weeePro);

    // Remove "per item" label
    if (this.quantity === 1 || !hasWeeePrices) {
      const { weeePriceLabelMulti, ...weeePrices } = this.weeePrices || {};

      return weeePrices;
    }

    return this.weeePrices;
  }

  @computed
  get subtotal() {
    if (!this.currency || !this.quantity || !this.price) {
      return 0;
    }

    return this.quantity * this.price;
  }

  @action.bound
  updateCompareDisabled() {
    this.compareDisabled = this.rootStore.comparatorStore.isComparatorFull && !this.isInComparator;
  }

  @action.bound
  updateIsInComparator(isIn) {
    this.isInComparator = isIn;
  }
}